export const PORTAL_STUDIO = 'studio'

export const LOGIN_METHODS = [
  // {
  //   label: 'Steam',
  //   icon: ['fab', 'steam-symbol'],
  //   background: 'tw-bg-steam tw-text-white',
  //   type: 'steam',
  //   url: '/steam/login',
  //   config: 'allowSteamAuth',
  // },
  // {
  //   label: 'Xbox Live',
  //   icon: ['fab', 'xbox'],
  //   background: 'tw-bg-xboxlive tw-text-white',
  //   type: 'xboxlive',
  //   url: '/xboxlive/login',
  //   config: 'allowXboxAuth',
  // },
  // {
  //   label: 'PlayStation™Network',
  //   icon: ['fab', 'playstation'],
  //   background: 'tw-bg-playstation tw-text-white',
  //   type: 'psn',
  //   url: '/psn/login',
  //   config: 'allowPsnAuth',
  // },
  // {
  //   label: 'Epic Games',
  //   icon: 'epic_logo',
  //   baseIcon: true,
  //   background: 'tw-bg-epicgames tw-text-white',
  //   type: 'egs',
  //   url: '/epicgames/login',
  //   config: 'allowEgsAuth',
  // },
  {
    label: 'Email',
    icon: 'envelope',
    type: 'email',
    url: '',
    config: 'allowEmailAuth',
  },
  // {
  //   label: 'Google',
  //   icon: ['fab', 'google'],
  //   background: 'tw-bg-google tw-text-white',
  //   type: 'google',
  //   url: '/google/login',
  //   config: 'allowGoogleAuth',
  // },
  // {
  //   label: 'Discord',
  //   icon: ['fab', 'discord'],
  //   background: 'tw-bg-discord tw-text-white',
  //   type: 'discord',
  //   url: '/discord/login',
  //   config: 'allowDiscordAuth',
  // },
  {
    label: 'Studio SSO',
    icon: 'gamepad',
    background: 'tw-button-primary-color game-primary-text',
    type: PORTAL_STUDIO,
    url: '/studio/login',
    config: 'allowSsoAuth',
  },
]
